export enum UnitDisplayFormat {
  abbr = 'abbr',
  short = 'short',
  full = 'full',
}

export enum DurationUnit {
  minute = 'minute',
  hour = 'hour',
  day = 'day',
}
